import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSignIcon } from "./DollarSignIcon";
import { useBudget } from "@/context/BudgetContext";

export const BudgetSummary = (): React.ReactNode => {
  const { budgetStats } = useBudget();

  // If no budget defined but has expenses, show total spent as current budget and 0 as remaining
  const hasBudget = (budgetStats.currentBudget || 0) > 0;
  const hasExpenses = (budgetStats.totalExpenses || 0) > 0;
  const noBudgetButHasExpenses = !hasBudget && hasExpenses;

  const displayCurrentBudget = noBudgetButHasExpenses
    ? budgetStats.totalExpenses || 0
    : budgetStats.currentBudget || 0;

  const displayRemainingBudget = noBudgetButHasExpenses
    ? 0
    : budgetStats.remainingBudget || 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Current Budget</CardTitle>
          <DollarSignIcon className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${displayCurrentBudget.toFixed(2)}
          </div>
        </CardContent>
      </Card>

      <Card className={displayRemainingBudget <= 0 ? 'bg-red-50' : ''}>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Remaining Budget</CardTitle>
          <DollarSignIcon className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${displayRemainingBudget.toFixed(2)}
          </div>
          <p className="text-xs text-muted-foreground">
            After ${(budgetStats.totalExpenses || 0).toFixed(2)} in expenses
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Allocations</CardTitle>
          <DollarSignIcon className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${(budgetStats.totalAllocations || 0).toFixed(2)}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Adjustments</CardTitle>
          <DollarSignIcon className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${(budgetStats.totalAdjustments || 0).toFixed(2)}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

